/**
 * @generated SignedSource<<d91575810a3a64c7adc879e42de9cec9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AssigneeFilterQuery$variables = {
  query?: string | null;
};
export type AssigneeFilterQuery$data = {
  readonly selectUsers: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly email: string;
        readonly fullName: string;
        readonly id: string;
        readonly image: string;
        readonly isGuest: boolean;
      };
    }>;
  } | null;
  readonly teams: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly title: string;
      };
    }>;
  } | null;
};
export type AssigneeFilterQuery = {
  response: AssigneeFilterQuery$data;
  variables: AssigneeFilterQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "query"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": "selectUsers",
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 15
      },
      {
        "kind": "Literal",
        "name": "isGuests",
        "value": false
      },
      {
        "kind": "Variable",
        "name": "search",
        "variableName": "query"
      }
    ],
    "concreteType": "UserConnection",
    "kind": "LinkedField",
    "name": "users",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "image",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fullName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isGuest",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 10
      },
      {
        "kind": "Variable",
        "name": "query",
        "variableName": "query"
      }
    ],
    "concreteType": "TeamConnection",
    "kind": "LinkedField",
    "name": "teams",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TeamEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AssigneeFilterQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AssigneeFilterQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "ce27bf75a5316a9b9d39b753289eda8c",
    "id": null,
    "metadata": {},
    "name": "AssigneeFilterQuery",
    "operationKind": "query",
    "text": "query AssigneeFilterQuery(\n  $query: String\n) {\n  selectUsers: users(first: 15, search: $query, isGuests: false) {\n    edges {\n      node {\n        id\n        email\n        image\n        fullName\n        isGuest\n      }\n    }\n  }\n  teams(first: 10, query: $query) {\n    edges {\n      node {\n        id\n        title\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e956a2422009cd095f866a543362a7f1";

export default node;
